import { useContext } from 'react';
import {
  CurrentApplicationContext,
  ICurrentApplicationContext,
} from '../contexts/CurrentApplicationContext';

export const useCurrentApplication = (): ICurrentApplicationContext => {
  const context = useContext(CurrentApplicationContext);
  return context;
};
